export default __webpack_public_path__ + "static/5-3b1ebbd388e1ccd8c13f1ec121ba14a7.jpg";